import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=ff806250&scoped=true&"
import script from "./Person.vue?vue&type=script&lang=js&"
export * from "./Person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff806250",
  null
  
)

export default component.exports